import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/i18n';
import { AuthenticationGuard } from './authentication.guard';
import { LoginComponent } from './login.component';
import { CreateAccountComponent } from './register/create-account/create-account.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ReactivateAccountComponent } from './reactivate-account/reactivate-account.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: { title: extract('Login') },
  },
  {
    path: 'register',
    component: CreateAccountComponent,
    data: { title: extract('Create Account') },
  },
  {
    path: 'forgotPassword',
    component: ForgotPasswordComponent,
    data: { title: extract('Forgot Password') },
  },
  {
    path: 'reactivate',
    component: ReactivateAccountComponent,
    data: { title: extract('Reactivate Account') },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AuthRoutingModule {}
